import React, { useEffect, useRef, useState } from "react";
import mapImage from "./assets/aboutus/map.png";
import planeImage from "./assets/aboutus/plane.png";
import shipImage from "./assets/aboutus/ship.png";

const AirToOceanSection = () => {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        setVisible(true);
        observer.disconnect(); // Stop observing after first trigger
      }
    },
    { threshold: 0.4 }
  );
  if (sectionRef.current) observer.observe(sectionRef.current);
  return () => observer.disconnect();
}, []);


  return (
    <section 
      ref={sectionRef}
      className="relative text-white px-6 md:px-16 pt-20 pb-32 overflow-hidden"
      
    >
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes fadeInLeft {
          from { opacity: 0; transform: translateX(-60px); }
          to { opacity: 1; transform: translateX(0); }
        }
        @keyframes fadeInRight {
          from { opacity: 0; transform: translateX(60px); }
          to { opacity: 1; transform: translateX(0); }
        }
        @keyframes typing {
          0% { width: 0 }
          100% { width: 100% }
        }
        .typing-text {
          overflow: hidden;
          white-space: nowrap;
          width: 0;
          animation: typing 0.8s steps(30, end) forwards;
        }
        .fade-left {
          opacity: 0;
          animation: fadeInLeft 0.8s ease-out forwards;
        }
        .fade-right {
          opacity: 0;
          animation: fadeInRight 0.8s ease-out forwards;
        }
        .fade-in {
          opacity: 0;
          animation: fadeIn 0.8s ease-out forwards;
        }
      `}</style>

      {/* Intro Paragraph */}
      <p
        className={`text-center text-[18px] max-w-4xl mx-auto leading-relaxed z-20 relative mb-16 ${
          visible ? "fade-in" : "opacity-0"
        }`}
        style={{ animationFillMode: "forwards" }}
      >
        <span className="font-bold text-[#00439C]">At Big Blue Inc.,</span> we don’t just move cargo, we move confidence
        across borders. As a <span className="font-bold text-[#00439C]">Canadian freight forwarding</span> company with{" "}
        <span className="font-bold text-[#00439C]">15+ years</span> of experience, we help businesses navigate global
        trade through precision driven logistics and people first service.
      </p>

      {/* Map Background Container */}
      <div
        className="relative w-full max-w-7xl mx-auto min-h-[500px] bg-no-repeat bg-center flex flex-col justify-around px-4 md:px-16"
        style={{
          backgroundImage: `url(${mapImage})`,
          backgroundSize: "contain",
        }}
      >
        {/* Top Row: From + Plane */}
        <div className="flex flex-col md:flex-row items-center justify-start z-10">
          <div className="text-left md:mr-6 mb-6 md:mb-0">
            <h2
              className={`text-[50px] md:text-[80px] font-bold leading-none mb-[-10px] ${
                visible ? "typing-text" : "opacity-0"
              }`}
              style={{ animationDelay: "0.2s", animationFillMode: "forwards" }}
            >
              From
            </h2>
            <h3
              className={`text-[24px] md:text-[40px] font-semibold ${
                visible ? "typing-text" : "opacity-0"
              }`}
              style={{ animationDelay: "0.2s", animationFillMode: "forwards" }}
            >
              Air Blue Routes
            </h3>
          </div>
          <img
            src={planeImage}
            alt="Plane"
            className={`w-[280px] md:w-[450px] ${visible ? "fade-left" : "opacity-0"}`}
            style={{ animationDelay: "1s", animationFillMode: "forwards" }}
          />
        </div>

        {/* Bottom Row: Ship + To */}
        <div className="flex flex-col-reverse md:flex-row items-center justify-end z-10 mt-10">
          <img
            src={shipImage}
            alt="Ship"
            className={`w-[300px] md:w-[550px] md:mr-6 ${visible ? "fade-right" : "opacity-0"}`}
            style={{ animationDelay: "2.4s", animationFillMode: "forwards" }}
          />
          <div className="text-right mb-6 md:mb-0">
            <h2
              className={`text-[50px] md:text-[80px] font-bold leading-none mb-[-10px] ${
                visible ? "typing-text" : "opacity-0"
              }`}
              style={{ animationDelay: "1.8s", animationFillMode: "forwards" }}
            >
              To
            </h2>
            <h3
              className={`text-[24px] md:text-[40px] font-semibold whitespace-nowrap ${
                visible ? "typing-text" : "opacity-0"
              }`}
              style={{ animationDelay: "1.8s", animationFillMode: "forwards" }}
            >
              Ocean Blue Lanes
            </h3>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AirToOceanSection;
